/**
 * Wisdom-大前端配置
 * 配置中心：https://config.hellobike.cn/#/project/detail?projectName=AppFinanceH5Web&projectGuid=8fa0876b0e60472b9cbf257a9bc63ad4
 * 接入说明：https://hellobike.yuque.com/gzxsb9/gt85o7/tfnhcgske2pxxwlr
 */

import { env } from '@/constant';
import type ConfigCenter from '@hb/wisdom-config-sdk';
import { ubtSendError } from '../utils/ubt';

let wisdomClientInstancePro: Promise<ConfigCenter> | null = null;

export type WisdomConfigData = Record<string, Dictionary> & { __comment__?: string };

const initWisdomClient = async (): Promise<ConfigCenter> => {
  if (!wisdomClientInstancePro) {
    wisdomClientInstancePro = new Promise(async (resolve, reject) => {
      try {
        const { default: ClientSDK } = await import('@hb/wisdom-config-sdk');

        const client = new ClientSDK({
          /** 环境 */
          env,
          /** 项目名称，新老项目存在使用相同配置的场景 */
          project: 'AppFinanceH5Web',
        });

        resolve(client);
      } catch (error) {
        reject(error);
      }
    });
  }

  return wisdomClientInstancePro;
};

/**
 * 读取大前端配置
 * @param keyCode 配置项key
 * @returns 配置项value
 */
export const getWisdomConfig = async <T = WisdomConfigData>(keyCode: string): Promise<T> => {
  try {
    const configCenter = await initWisdomClient();
    const config = await configCenter.get<WisdomConfigData>(keyCode, {} as WisdomConfigData);

    if (config?.__comment__) {
      /** 自定义的注释，在此处删除 */
      delete (config as Dictionary).__comment__;
    }

    return config as unknown as T;
  } catch (error) {
    ubtSendError(error as Error);
    return {} as unknown as T;
  }
};

/** 预初始化wisdom-sdk实例 */
export const preloadWisdomClient = async (): Promise<void> => {
  try {
    await initWisdomClient();
  } catch (error) {
    ubtSendError({
      name: 'load-wisdom-client-error',
      message: (error as Error)?.message,
    });
  }
};
